
// import React from 'react';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import { ThemeProvider as MuiThemeProvider } from '@mui/material';
// import CssBaseline from '@mui/material/CssBaseline';
// import { Provider } from 'react-redux';
// import { SnackbarProvider } from 'notistack';
// import { getTheme } from './theme';
// import { store } from './app/store';
// import { AuthProvider, useAuth } from './context/AuthContext';
// import { ThemeProvider as CustomThemeProvider, useTheme } from './context/ThemeContext';
// import MainLayout from './layouts/MainLayout';
// import Login from './pages/Login';
// import Signup from './pages/Signup';
// import ChangePassword from './pages/ChangePassword';  // 👈 ADD THIS IMPORT
// import Dashboard from './pages/Dashboard/Dashboard';
// import Vendors from './pages/Vendors/Vendors';
// import AddVendor from './pages/Vendors/AddVendor';
// import VendorDetails from './pages/Vendors/VendorDetails';
// import UnifiedScan from './pages/Scans/UnifiedScan';
// import ScanProgress from './pages/Scans/ScanProgress';
// import ScanResults from './pages/Scans/ScanResults';
// import Reports from './pages/Reports/Reports';
// import VendorComparison from './pages/Reports/VendorComparison';
// import Settings from './pages/Settings/Settings';
// import APIKeys from './pages/Settings/APIKeys';
// import FinancialProviders from './pages/Settings/FinancialProviders';
// import Monitoring from './pages/Monitoring/Monitoring';
// import Users from './pages/Users/Users';
// import AddUser from './pages/Users/AddUser';
// import AuditLogs from './pages/AuditLogs/AuditLogs';
// import ForgotPassword from './pages/ForgotPassword';
// import ResetPassword from './pages/ResetPassword';
// import Questionnaires from './pages/Questionnaires/Questionnaires';

// // Protected Route wrapper
// const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const { isAuthenticated, isLoading } = useAuth();
  
//   if (isLoading) {
//     return <div>Loading...</div>;
//   }
  
//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }
  
//   return <>{children}</>;
// };

// function AppRoutes() {
//   const { isAuthenticated } = useAuth();
  
//   return (
//     <Routes>
//       {/* ============ PUBLIC ROUTES ============ */}
//       <Route path="/login" element={
//         isAuthenticated ? <Navigate to="/" replace /> : <Login />
//       } />
//       <Route path="/signup" element={
//         isAuthenticated ? <Navigate to="/" replace /> : <Signup />
//       } />
      
//       {/* ============ FORGOT PASSWORD - PUBLIC ============ */}
//       <Route path="/forgot-password" element={<ForgotPassword />} />
//       <Route path="/reset-password" element={<ResetPassword />} />
      
//       {/* ============ CHANGE PASSWORD - PUBLIC ============ */}
//       <Route path="/change-password" element={<ChangePassword />} />  {/* 👈 ADD THIS ROUTE */}
      
//       {/* ============ PROTECTED ROUTES ============ */}
//       <Route path="/" element={
//         <ProtectedRoute>
//           <MainLayout />
//         </ProtectedRoute>
//       }>
//         {/* Main Pages */}
//         <Route index element={<Dashboard />} />
//         <Route path="dashboard" element={<Dashboard />} />
        
//         {/* Monitoring */}
//         <Route path="monitoring" element={<Monitoring />} />
        
//         {/* Vendors */}
//         <Route path="vendors" element={<Vendors />} />
//         <Route path="vendors/add" element={<AddVendor />} />
//         <Route path="vendors/:vendorId" element={<VendorDetails />} />
        
//         {/* Scans */}
//         <Route path="scans" element={<UnifiedScan />} />
//         <Route path="scans/new" element={<UnifiedScan />} />
//         <Route path="scans/bulk" element={<UnifiedScan />} />
//         <Route path="scans/:scanId/progress" element={<ScanProgress />} />
//         <Route path="scans/:scanId/results" element={<ScanResults />} />
        
//         {/* Reports */}
//         <Route path="reports" element={<Reports />} />
//         <Route path="reports/comparison" element={<VendorComparison />} />
        
//         {/* Questionnaires */}
//         <Route path="questionnaires" element={<Questionnaires />} />
        
//         {/* Users */}
//         <Route path="users" element={<Users />} />
//         <Route path="users/add" element={<AddUser />} />
//         <Route path="users/:userId/edit" element={<AddUser />} />
        
//         {/* Audit Logs */}
//         <Route path="audit-logs" element={<AuditLogs />} />
        
//         {/* Settings */}
//         <Route path="settings" element={<Settings />} />
//         <Route path="settings/api-keys" element={<APIKeys />} />
//         <Route path="settings/financial-providers" element={<FinancialProviders />} />
        
//         {/* Catch all - redirect to dashboard */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Route>
//     </Routes>
//   );
// }

// // Inner component to access theme context
// const AppContent: React.FC = () => {
//   const { mode } = useTheme();
//   const theme = getTheme(mode);

//   return (
//     <MuiThemeProvider theme={theme}>
//       <CssBaseline />
//       <SnackbarProvider 
//         maxSnack={3} 
//         anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//         autoHideDuration={5000}
//       >
//         <BrowserRouter>
//           <AuthProvider>
//             <AppRoutes />
//           </AuthProvider>
//         </BrowserRouter>
//       </SnackbarProvider>
//     </MuiThemeProvider>
//   );
// };

// function App() {
//   return (
//     <Provider store={store}>
//       <CustomThemeProvider>
//         <AppContent />
//       </CustomThemeProvider>
//     </Provider>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigationType } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { getTheme } from './theme';
import { store } from './app/store';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider as CustomThemeProvider, useTheme } from './context/ThemeContext';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Terms from './pages/Legal/Terms';
import Privacy from './pages/Legal/Privacy';
import VendorPortalTerms from './pages/Legal/VendorPortalTerms';
import ChangePassword from './pages/ChangePassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Vendors from './pages/Vendors/Vendors';
import AddVendor from './pages/Vendors/AddVendor';
import VendorDetails from './pages/Vendors/VendorDetails';
import QuestionnaireLibrary from './pages/Questionnaires/QuestionnaireLibrary';
import QuestionnairePreview from './pages/Questionnaires/QuestionnairePreview';
import QuestionnaireBuilder from './pages/Questionnaires/QuestionnaireBuilder';
import VendorRequests from './pages/VendorRequests/VendorRequests';
import Remediation from './pages/Remediation/Remediation';
import RemediationDetail from './pages/Remediation/RemediationDetail';
import PortalRemediation from './pages/QuestionnaireResponse/PortalRemediation';
import PortalRating from './pages/QuestionnaireResponse/PortalRating';
import ScanProgress from './pages/Scans/ScanProgress';
import ScanResults from './pages/Scans/ScanResults';
import Reports from './pages/Reports/Reports';
import VendorComparison from './pages/Reports/VendorComparison';
import FourthPartiesPortfolio from './pages/Reports/FourthPartiesPortfolio';
import Help from './pages/Help/Help';
import MyRisk from './pages/MyRisk/MyRisk';
import Settings from './pages/Settings/Settings';
import Monitoring from './pages/Monitoring/Monitoring';
import Schedule from './pages/Schedule/Schedule';
import Users from './pages/Users/Users';
import AddUser from './pages/Users/AddUser';
import AuditLogs from './pages/AuditLogs/AuditLogs';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AnswerQuestionnaire from './pages/QuestionnaireResponse/AnswerQuestionnaire';
import PortalGate from './pages/QuestionnaireResponse/PortalGate';
import PortalRegister from './pages/QuestionnaireResponse/PortalRegister';
import PortalVerify from './pages/QuestionnaireResponse/PortalVerify';
import PortalForgotPassword from './pages/QuestionnaireResponse/PortalForgotPassword';
import PortalResetPassword from './pages/QuestionnaireResponse/PortalResetPassword';
import PortalDocuments from './pages/QuestionnaireResponse/PortalDocuments';
import PortalAccount from './pages/QuestionnaireResponse/PortalAccount';
import PortalLogin from './pages/QuestionnaireResponse/PortalLogin';
import PortalDashboard from './pages/QuestionnaireResponse/PortalDashboard';
import PortalResponseDetail from './pages/QuestionnaireResponse/PortalResponseDetail';
import { PortalAuthProvider } from './context/PortalAuthContext';
import { PortalProtectedRoute } from './pages/QuestionnaireResponse/PortalWidgets';

// Opening a different page starts at its top. Without this the window keeps the previous page's scroll position
// (a single-page app never reloads), so e.g. a scan report opened from far down a vendor page started mid-way.
// Only the path counts: ?tab= changes inside a page keep their place, and Back / Forward (POP) are left alone.
function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  React.useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navigationType]);
  return null;
}

// Protected Route wrapper
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  
  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Signed in with the temporary password from an invite: nothing opens until it is changed.
  if (user?.require_password_reset) {
    return <Navigate to="/change-password" replace />;
  }
  
  return <>{children}</>;
};

function AppRoutes() {
  const { isAuthenticated, user } = useAuth();
  
  return (
    <Routes>
      {/* ============ PUBLIC ROUTES ============ */}
      <Route path="/login" element={
        isAuthenticated ? <Navigate to={user?.require_password_reset ? '/change-password' : '/'} replace /> : <Login />
      } />
      <Route path="/signup" element={
        isAuthenticated ? <Navigate to="/" replace /> : <Signup />
      } />
      
      {/* ============ LEGAL - PUBLIC. Built in-app (not on fluxvell.com) since these agreements
          are for using FluxWatch itself -- see Signup.tsx's consent modal and
          AnswerQuestionnaire.tsx's EUA screen, which link here. ============ */}
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/vendor-portal-terms" element={<VendorPortalTerms />} />

      {/* ============ FORGOT PASSWORD - PUBLIC ============ */}
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* ============ CHANGE PASSWORD - PUBLIC ============ */}
      <Route path="/change-password" element={<ChangePassword />} />

      {/* ============ VENDOR RECIPIENT PORTAL - separate account/session from the tenant app,
          see PortalAuthContext.tsx. Wrapped in its own provider here since none of these pages
          are part of the authenticated tenant tree above. ============ */}
      <Route path="/questionnaire/portal/*" element={
        <PortalAuthProvider>
          <Routes>
            <Route path="/" element={<PortalGate />} />
            <Route path="register" element={<PortalRegister />} />
            <Route path="verify" element={<PortalVerify />} />
            <Route path="login" element={<PortalLogin />} />
            <Route path="forgot-password" element={<PortalForgotPassword />} />
            <Route path="reset-password" element={<PortalResetPassword />} />
            <Route path="dashboard" element={<PortalProtectedRoute><PortalDashboard /></PortalProtectedRoute>} />
            <Route path="documents" element={<PortalProtectedRoute><PortalDocuments /></PortalProtectedRoute>} />
            <Route path="remediation" element={<PortalProtectedRoute><PortalRemediation /></PortalProtectedRoute>} />
            <Route path="remediation/:requestId" element={<PortalProtectedRoute><PortalRemediation /></PortalProtectedRoute>} />
            <Route path="rating" element={<PortalProtectedRoute><PortalRating /></PortalProtectedRoute>} />
            <Route path="account" element={<PortalProtectedRoute><PortalAccount /></PortalProtectedRoute>} />
            <Route path="response/:responseId" element={<PortalProtectedRoute><PortalResponseDetail /></PortalProtectedRoute>} />
            <Route path="answer/:responseId" element={<PortalProtectedRoute><AnswerQuestionnaire /></PortalProtectedRoute>} />
          </Routes>
        </PortalAuthProvider>
      } />

      {/* Standalone (no MainLayout chrome) so its own full-viewport sticky/fixed layout isn't
          fighting the app shell's own scroll container -- same reason the old vendor portal
          page was standalone. Platform-wide, not tied to any vendor. */}
      <Route path="/questionnaire-library/:questionnaireId/preview" element={
        <ProtectedRoute><QuestionnairePreview /></ProtectedRoute>
      } />
      <Route path="/questionnaire-library/:questionnaireId/builder" element={
        <ProtectedRoute><QuestionnaireBuilder /></ProtectedRoute>
      } />

      {/* ============ PROTECTED ROUTES ============ */}
      <Route path="/" element={
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      }>
        {/* Main Pages */}
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        
        {/* Monitoring */}
        <Route path="monitoring" element={<Monitoring />} />
        <Route path="schedule" element={<Schedule />} />
        
        {/* Vendors */}
        <Route path="vendors" element={<Vendors />} />
        <Route path="vendors/add" element={<AddVendor />} />
        <Route path="vendors/:vendorId" element={<VendorDetails />} />
        <Route path="vendor-requests" element={<VendorRequests />} />
        <Route path="vendor-requests/:requestId" element={<VendorRequests />} />
        <Route path="remediation" element={<Remediation />} />
        <Route path="remediation/:requestId" element={<RemediationDetail />} />

        {/* Questionnaire Library -- a platform-wide catalog, not tied to any vendor */}
        <Route path="questionnaire-library" element={<QuestionnaireLibrary />} />

        {/* Scans */}
        {/* The Scan page was removed: scans start from a vendor (Fast / Deep). Old links land on Vendors. */}
        <Route path="scans" element={<Navigate to="/vendors" replace />} />
        <Route path="scans/new" element={<Navigate to="/vendors" replace />} />
        <Route path="scans/bulk" element={<Navigate to="/vendors" replace />} />
        <Route path="scans/:scanId/progress" element={<ScanProgress />} />
        <Route path="scans/:scanId/results" element={<ScanResults />} />
        
        {/* Reports */}
        <Route path="reports" element={<Reports />} />
        <Route path="reports/comparison" element={<VendorComparison />} />
        <Route path="fourth-parties" element={<FourthPartiesPortfolio />} />
        <Route path="help" element={<Help />} />
        
        {/* Users */}
        <Route path="users" element={<Users />} />
        <Route path="users/add" element={<AddUser />} />
        <Route path="users/:userId/edit" element={<AddUser />} />
        
        {/* Audit Logs */}
        <Route path="audit-logs" element={<AuditLogs />} />
        
        {/* Settings */}
        <Route path="settings" element={<Settings />} />
        <Route path="my-organization" element={<MyRisk />} />
        <Route path="my-risk" element={<Navigate to="/my-organization" replace />} />
        <Route path="settings/api-keys" element={<Navigate to="/settings" replace />} />
        <Route path="settings/financial-providers" element={<Navigate to="/settings?section=financial" replace />} />
        
        {/* 👈 PROFILE ROUTE REMOVED - Now using Drawer */}
        
        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

// Inner component to access theme context
const AppContent: React.FC = () => {
  const { mode } = useTheme();
  const theme = getTheme(mode);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider 
        maxSnack={3} 
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={5000}
      >
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </SnackbarProvider>
    </MuiThemeProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <CustomThemeProvider>
        <AppContent />
      </CustomThemeProvider>
    </Provider>
  );
}

export default App;